'use strict';

var jsxRuntime = require('react/jsx-runtime');

const DocumentSuccess = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-document_success--disabled",
            children: [
                jsxRuntime.jsx("path", {
                    d: "M6 16C6 13.7909 7.79086 12 10 12H22C24.2091 12 26 13.7909 26 16V17H42C44.2091 17 46 18.7909 46 21V44C46 46.2091 44.2091 48 42 48H9C7.34315 48 6 46.6569 6 45V16Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("rect", {
                    x: "10",
                    y: "22",
                    width: "32",
                    height: "26",
                    rx: "2",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("rect", {
                    x: "14",
                    y: "22",
                    width: "32",
                    height: "26",
                    rx: "2",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.53125 48H42.7999C44.5417 48 46.0832 46.8729 46.6115 45.2132L52.341 27.2132C53.1621 24.6334 51.2368 22 48.5294 22H22.925C21.1833 22 19.6418 23.1271 19.1135 24.7868L12.3899 45.9099C11.9937 47.1547 10.8376 48 9.53125 48Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("circle", {
                    cx: "48",
                    cy: "44",
                    r: "8",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M45 43.6L47.25 46L51 42",
                    stroke: "white",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-document_success",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("path", {
                d: "M6 16C6 13.7909 7.79086 12 10 12H22C24.2091 12 26 13.7909 26 16V17H42C44.2091 17 46 18.7909 46 21V44C46 46.2091 44.2091 48 42 48H9C7.34315 48 6 46.6569 6 45V16Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("rect", {
                x: "10",
                y: "22",
                width: "32",
                height: "26",
                rx: "2",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("rect", {
                x: "14",
                y: "22",
                width: "32",
                height: "26",
                rx: "2",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.53125 48H42.7999C44.5417 48 46.0832 46.8729 46.6115 45.2132L52.341 27.2132C53.1621 24.6334 51.2368 22 48.5294 22H22.925C21.1833 22 19.6418 23.1271 19.1135 24.7868L12.3899 45.9099C11.9937 47.1547 10.8376 48 9.53125 48Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("circle", {
                cx: "48",
                cy: "44",
                r: "8",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M45 43.6L47.25 46L51 42",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

module.exports = DocumentSuccess;
